import { DEFAULT_ACTION_TAB, isActionTab, type ActionTab } from "./action-tab";

const TAB_STORAGE_KEY = "action-tab";
const COLLAPSED_STORAGE_KEY = "action-collapsed";

export function readStoredActionTab(): ActionTab {
  try {
    const stored = sessionStorage.getItem(TAB_STORAGE_KEY);
    return isActionTab(stored) ? stored : DEFAULT_ACTION_TAB;
  } catch {
    return DEFAULT_ACTION_TAB;
  }
}

export function storeActionTab(tab: ActionTab): void {
  try {
    sessionStorage.setItem(TAB_STORAGE_KEY, tab);
  } catch {
    /* persistence is best-effort */
  }
}

export function readStoredActionCollapsed(): boolean {
  try {
    return sessionStorage.getItem(COLLAPSED_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function storeActionCollapsed(collapsed: boolean): void {
  try {
    sessionStorage.setItem(COLLAPSED_STORAGE_KEY, String(collapsed));
  } catch {
    /* persistence is best-effort */
  }
}
